module.exports = __webpack_public_path__ + "./fonts/Tajawal-Bold.ttf";